import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTwitter = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 32 32",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M17.969 14.162L26.706 4h-2.07l-7.587 8.824L10.989 4H4l9.163 13.343L4 28h2.07l8.013-9.318 6.4 9.318h6.988l-9.503-13.838zm-2.836 3.299l-.929-1.329L6.817 5.56h3.18l5.962 8.532.928 1.329 7.75 11.09h-3.18l-6.324-9.05z" })
});
export default SvgTwitter;
